import { render, staticRenderFns } from "./IIPDCDevice.vue?vue&type=template&id=f09c5e5c&scoped=true&"
import script from "./IIPDCDevice.vue?vue&type=script&lang=js&"
export * from "./IIPDCDevice.vue?vue&type=script&lang=js&"
import style0 from "./IIPDCDevice.vue?vue&type=style&index=0&id=f09c5e5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09c5e5c",
  null
  
)

export default component.exports